import { NgModule } from '@angular/core';
import { ActivatedRouteSnapshot, PreloadAllModules, RouterModule, RouterStateSnapshot, Routes } from '@angular/router';

import { PublicLayoutComponent } from './core/layouts/public.layout';
import { AuthGuard, redirectUnauthorizedTo } from './shared/guards/auth.guard';
import { MfaEnforcementGuard } from './shared/guards/mfa-enforcement.guard';
import { PrivateLayoutComponent } from './core/layouts/private.layout';
import { ErrorComponent } from './error/error.component';
import { NotFoundComponent } from './error/not-found.component';
import { NotFoundRedirectComponent } from './error/not-found-redirect.component';
import { ContactComponent } from './contact/contact.component';

const redirectUnauthorizedToSignIn = (_: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return redirectUnauthorizedTo(['signin', { returnTo: state.url }]);
};

const routes: Routes = [
  {
    path: 'widget',
    loadChildren: () => import('./widget/widget.module').then(m => m.WidgetModule)
  },
  {
    path: '',
    component: PrivateLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [MfaEnforcementGuard],
    data: {
      authGuardPipe: redirectUnauthorizedToSignIn
    },
    children: [
      {
        path: 'security',
        loadChildren: () => import('./security/security.module').then(m => m.SecurityModule)
      },
      {
        path: '',
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'not-found',
        component: NotFoundComponent,
        data: { type: 'not-found', title: 'Page Not Found' }
      },
      {
        path: 'forbidden',
        component: NotFoundComponent,
        data: { type: 'forbidden', title: 'Access Denied' }
      },
      {
        path: 'error',
        component: NotFoundComponent,
        data: { type: 'error', title: 'Error' }
      }
    ]
  },
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      {
        path: 'signup',
        loadChildren: () => import('./onboarding/onboarding.module').then(m => m.OnboardingModule)
      },
      {
        path: 'promo',
        loadChildren: () => import('./promo/promo.module').then(m => m.PromoModule)
      },
      {
        path: 'signin',
        loadChildren: () => import('./sign-in/sign-in.module').then(m => m.SignInModule)
      },
      {
        path: 'signout',
        loadChildren: () => import('./sign-out/sign-out.module').then(m => m.SignOutModule)
      },
      {
        path: 'password',
        loadChildren: () => import('./password-reset/password-reset.module').then(m => m.PasswordResetModule)
      },
      {
        path: 'auth',
        loadChildren: () => import('./auth-action/auth-action.module').then(m => m.AuthActionModule)
      },
      {
        path: 'privacy',
        loadChildren: () => import('./privacy/privacy.module').then(m => m.PrivacyModule)
      },
      {
        path: 'terms',
        loadChildren: () => import('./terms/terms.module').then(m => m.TermsModule)
      }
    ]
  },
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      {
        path: 'contact',
        component: ContactComponent,
        data: {
          title: 'Contact'
        }
      },
      {
        path: 'error',
        component: ErrorComponent,
        data: {
          title: 'Error'
        }
      },
    ]
  },
  {
    path: '**',
    component: NotFoundRedirectComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking',
    preloadingStrategy: PreloadAllModules,
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
